import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import isClient from 'commons/isClient';
import isProd from 'commons/isProd';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';
const SCRIPT_ID = 'bazaarvoice-script';
const BV_CLIENT = 'joybird';
const BV_SITE_ID = 'main_site';
const BV_LOCALE = 'en_US';
const getBVEnvironment = () => isProd() ? 'production' : 'staging';
const getBVScriptUrl = () => {
  const env = getBVEnvironment();
  return `https://apps.bazaarvoice.com/deployments/${BV_CLIENT}/${BV_SITE_ID}/${env}/${BV_LOCALE}/bv.js`;
};
const loadBVScript = callback => {
  if (!isClient()) return;
  const existingScript = document.getElementById(SCRIPT_ID);
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = getBVScriptUrl();
    script.id = SCRIPT_ID;
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  } else if (callback) {
    callback();
  }
};
export const useBazaarVoiceEnabled = () => {
  const flagValue = usePostHogFeatureFlag("bazaarvoice-enabled");
  return flagValue === true;
};
const useBazaarVoice = () => {
  const $ = _c(5);
  const [isReady, setIsReady] = useState(false);
  const isEnabled = useBazaarVoiceEnabled();
  let t0;
  let t1;
  if ($[0] !== isEnabled) {
    t0 = () => {
      if (isEnabled) {
        loadBVScript(() => setIsReady(true));
      }
    };
    t1 = [isEnabled];
    $[0] = isEnabled;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== isReady) {
    t2 = {
      isReady
    };
    $[3] = isReady;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default useBazaarVoice;